const marketplaceFlags: { [key: string]: string } = {
  fr: "🇫🇷",
  it: "🇮🇹",
  es: "🇪🇸",
  de: "🇩🇪",
  en: "🇺🇸",
  "en-gb": "🇬🇧",
  "en-ca": "🇨🇦",
  "es-mx": "🇲🇽",
  us: "🇺🇸",
  jp: "🇯🇵",
  pl: "🇵🇱",
  sv: "🇸🇪",
  se: "🇸🇪",
  nl: "🇳🇱",
  tr: "🇹🇷",
  be: "🇧🇪",
  ie: "🇮🇪",
  ar: "🇦🇪",
  "ar-sa": "🇸🇦",
  "ar-eg": "🇪🇬",
  pt: "🇧🇷",
  ca: "🇨🇦",
  mx: "🇲🇽",
  br: "🇧🇷",
};

export default marketplaceFlags;
